"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeveloperWithStructurePropertyType = exports.FromDeveloperTypes = void 0;
exports.FromDeveloperTypes = {
    hy: {
        sell: {
            apartment: 'bnakaran-karucapatoghic-',
            house: 'sepakan-tun-karucapatoghic-',
            commercial: 'komercion-tarack-karucapatoghic-',
        },
        rent: {
            apartment: 'bnakaran-karucapatoghic-',
            house: 'sepakan-tun-karucapatoghic-',
            commercial: 'grasenyakayin-taracq-karucapatoghic-',
        },
    },
    ru: {
        sell: {
            apartment: 'kvartiri-ot-zastroishika-',
            house: 'chastniy-dom-ot-zastroishika-',
            commercial: 'kommercheskaya-nedvizhimost-ot-zastroishika-',
        },
        rent: {
            apartment: 'kvartiri-ot-zastroishika-',
            house: 'chastniy-dom-ot-zastroishika-',
            commercial: 'kommercheskaya-nedvizhimost-ot-zastroishika-',
        },
    },
    en: {
        sell: {
            apartment: 'apartment-new-development-',
            house: 'house-new-development-',
            commercial: 'commercial-new-development-',
        },
        rent: {
            apartment: 'apartment-new-development-',
            house: 'house-new-development-',
            commercial: 'commercial-new-development-',
        },
    },
};
exports.DeveloperWithStructurePropertyType = {
    hy: {
        sell: {
            apartment: 'norakaruyc-bnakaran-karucapatoghic-',
            house: 'norakaruyc-sepakan-tun-karucapatoghic-',
            commercial: 'norakaruyc-komercion-tarack-karucapatoghic-',
        },
        rent: {
            apartment: 'norakaruyc-bnakaran-karucapatoghic-',
            house: 'norakaruyc-arandznatun-karucapatoghic-',
            commercial: 'norakaruyc-komercion-tarack-karucapatoghic-',
        },
    },
    ru: {
        sell: {
            apartment: 'kvartiri-v-novostroikax-ot-zastroishika-',
            house: 'chastnie-doma-novostroiki-ot-zastroishika-',
            commercial: 'kommercheskaya-nedvizhimost-v-novostroikax-ot-zastroishika-',
        },
        rent: {
            apartment: 'kvartiri-v-novostroikax-ot-zastroishika-',
            house: 'chastnie-doma-novostroiki-ot-zastroishika-',
            commercial: 'kommercheskaya-nedvizhimost-v-novostroikax-ot-zastroishika-',
        },
    },
    en: {
        sell: {
            apartment: 'new-apartment-new-development-',
            house: 'new-house-new-development-',
            commercial: 'new-commercial-new-development-',
        },
        rent: {
            apartment: 'new-apartment-new-development-',
            house: 'new-house-new-development-',
            commercial: 'new-commercial-new-development-',
        },
    },
};
